import React from 'react';
import { Lock, Unlock } from 'lucide-react';

export const StagePartyInfo = function({ planData, updateData, togglePartyLock }) {
  return (

          <div className="space-y-6">
            {/* Lock Toggle */}
            <div className="flex items-center justify-end">
              <button onClick={togglePartyLock}
                className={'flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-all border ' +
                  (planData.partyInfoLocked ? 'bg-[#10B981]/15 border-[#10B981]/30 text-[#10B981]' : 'bg-white/[0.03] border-white/[0.06] text-white/40 hover:text-white/60')}
                data-testid="party-lock-toggle">
                {planData.partyInfoLocked ? <Lock className="w-3.5 h-3.5" /> : <Unlock className="w-3.5 h-3.5" />}
                {planData.partyInfoLocked ? 'Saved — Click to Unlock' : 'Save Party Info'}
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2">Court Name</label>
                <input
                  type="text"
                  value={planData.courtName}
                  onChange={(e) => updateData('courtName', e.target.value)}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                  placeholder="e.g., District Court"
                  data-testid="plan-court-name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Court Address</label>
                <input
                  type="text"
                  value={planData.courtAddress}
                  onChange={(e) => updateData('courtAddress', e.target.value)}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                  placeholder="e.g., 123 Main St, City, State 12345"
                  data-testid="plan-court-address"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Case Number</label>
                <input
                  type="text"
                  value={planData.caseNumber}
                  onChange={(e) => updateData('caseNumber', e.target.value)}
                  className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                  placeholder="e.g., 2024DR12345"
                  data-testid="plan-case-number"
                />
              </div>
            </div>

            {/* Plaintiff Section */}
            <div className="border border-[#3B82F6]/30 bg-[#3B82F6]/5 rounded-xl p-5 space-y-4">
              <h4 className="font-semibold text-[#3B82F6] text-sm uppercase tracking-wider">Plaintiff</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Full Legal Name</label>
                  <input type="text" value={planData.plaintiffName}
                    onChange={(e) => updateData('plaintiffName', e.target.value)}
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                    placeholder="First Middle Last"
                    data-testid="plan-plaintiff-name" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Street Address</label>
                  <input type="text" value={planData.plaintiffAddress}
                    onChange={(e) => updateData('plaintiffAddress', e.target.value)}
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                    placeholder="123 Main Street"
                    data-testid="plan-plaintiff-address" />
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div>
                    <label className="block text-sm font-medium mb-2">City</label>
                    <input type="text" value={planData.plaintiffCity}
                      onChange={(e) => updateData('plaintiffCity', e.target.value)}
                      className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                      placeholder="City"
                      data-testid="plan-plaintiff-city" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">State</label>
                    <input type="text" value={planData.plaintiffState}
                      onChange={(e) => updateData('plaintiffState', e.target.value)}
                      className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                      placeholder="State"
                      data-testid="plan-plaintiff-state" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Zip</label>
                    <input type="text" value={planData.plaintiffZip}
                      onChange={(e) => updateData('plaintiffZip', e.target.value)}
                      className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                      placeholder="Zip"
                      data-testid="plan-plaintiff-zip" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Phone Number</label>
                  <input type="tel" value={planData.plaintiffPhone}
                    onChange={(e) => updateData('plaintiffPhone', e.target.value)}
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                    placeholder="(555) 123-4567"
                    data-testid="plan-plaintiff-phone" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Email Address</label>
                  <input type="email" value={planData.plaintiffEmail}
                    onChange={(e) => updateData('plaintiffEmail', e.target.value)}
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                    placeholder="plaintiff@email.com"
                    data-testid="plan-plaintiff-email" />
                </div>
              </div>
            </div>

            {/* Defendant Section */}
            <div className="border border-[#EC4899]/30 bg-[#EC4899]/5 rounded-xl p-5 space-y-4">
              <h4 className="font-semibold text-[#EC4899] text-sm uppercase tracking-wider">Defendant</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Full Legal Name</label>
                  <input type="text" value={planData.defendantName}
                    onChange={(e) => updateData('defendantName', e.target.value)}
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                    placeholder="First Middle Last"
                    data-testid="plan-defendant-name" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Street Address</label>
                  <input type="text" value={planData.defendantAddress}
                    onChange={(e) => updateData('defendantAddress', e.target.value)}
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                    placeholder="456 Oak Avenue"
                    data-testid="plan-defendant-address" />
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div>
                    <label className="block text-sm font-medium mb-2">City</label>
                    <input type="text" value={planData.defendantCity}
                      onChange={(e) => updateData('defendantCity', e.target.value)}
                      className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                      placeholder="City"
                      data-testid="plan-defendant-city" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">State</label>
                    <input type="text" value={planData.defendantState}
                      onChange={(e) => updateData('defendantState', e.target.value)}
                      className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                      placeholder="State"
                      data-testid="plan-defendant-state" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Zip</label>
                    <input type="text" value={planData.defendantZip}
                      onChange={(e) => updateData('defendantZip', e.target.value)}
                      className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                      placeholder="Zip"
                      data-testid="plan-defendant-zip" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Phone Number</label>
                  <input type="tel" value={planData.defendantPhone}
                    onChange={(e) => updateData('defendantPhone', e.target.value)}
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                    placeholder="(555) 987-6543"
                    data-testid="plan-defendant-phone" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Email Address</label>
                  <input type="email" value={planData.defendantEmail}
                    onChange={(e) => updateData('defendantEmail', e.target.value)}
                    className="w-full bg-white/5 border border-white/10 text-white rounded-lg px-4 py-2"
                    placeholder="defendant@email.com"
                    data-testid="plan-defendant-email" />
                </div>
              </div>
            </div>
          </div>
        
  );
};
